// Section for import npm components -----------------------------------------------------------------------------------
import React, { ReactElement } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

// Material UI ( mui )  components
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { styled, TooltipProps, tooltipClasses } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Section for import custom components --------------------------------------------------------------------------------
import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
import MansionOverViewPropsData from '@/types/components/MansionDetail/MansionOverViewPropsData';

const commonUtil = CommonUtility;

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#F7F7F7',
    color: '#191919',
    fontSize: '12px',
  },
}));

export default function MansionOverView(props: MansionOverViewPropsData): ReactElement {
  const { address, mansionTransit, buildCreatedDate, petStatus } = props;
  const isMobile = useMediaQuery('(max-width:767px)');
  const [open, setOpen] = React.useState(false);
  let timeoutId: NodeJS.Timeout | null = null;

  const handleTooltipClose = () => {
    timeoutId = setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  const handleTooltipOpen = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setOpen(true);
  };

  const convertMansionTransit: {
    key: string;
    transit: string[];
  }[] = mansionTransit.map((value: string[], index: number) => {
    return {
      key: `transit-${commonUtil.convertNumberToString(index)}`,
      transit: value,
    };
  });

  return (
    <section className="md:max-w-7xl md:w-full md:mx-auto md:px-24 max-md:mx-5 py-4 max-md:py-2">
      <dl className="md:flex pb-4 max-md:pb-2 border-b border-gray-02">
        <dt className="md:w-[116px] max-md:w-full max-md:mb-1 text-sm leading-6 font-bold text-gray-04">所在地</dt>
        <dd className="text-base">{address}</dd>
      </dl>
      <dl className="md:flex pt-8 max-md:pt-5 pb-4 max-md:pb-2 border-b border-gray-02">
        <dt className="md:w-[116px] max-md:w-full  max-md:mb-1  text-sm leading-6 font-bold text-gray-04">アクセス</dt>
        <dd className="text-base">
          {convertMansionTransit.map((item) => (
            <span key={item.key} className="block leading-6">
              {item.transit}
            </span>
          ))}
        </dd>
      </dl>
      <dl className="md:flex pt-8 max-md:pt-5 pb-4 max-md:pb-2 border-b border-gray-02">
        <dt className="md:w-[116px] max-md:w-full  max-md:mb-1  text-sm leading-6 font-bold text-gray-04">築年月</dt>
        <dd className="text-base">{buildCreatedDate}</dd>
      </dl>
      <dl className="md:flex pt-8 max-md:pt-5 pb-4 max-md:pb-2 border-b border-gray-02">
        <dt className="md:w-[116px] max-md:w-full  max-md:mb-1  text-sm leading-6 font-bold text-gray-04">
          ペット飼育
          <CustomTooltip
            title="最新情報は現行と異なる場合がございます"
            enterDelay={100}
            placement="bottom-start"
            PopperProps={{
              disablePortal: true, // Tooltip表示のイベントをカスタマイズ可能にする為、trueにする
              popperOptions: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, isMobile ? -12 : -8], // x方向のオフセット, y方向のオフセット
                    },
                  },
                ],
              },
            }}
            onClose={isMobile ? handleTooltipClose : undefined}
            open={isMobile ? open : undefined}
          >
            <IconButton className="mb-[3px] py-0 px-2" onClick={isMobile ? handleTooltipOpen : undefined}>
              <InfoOutlinedIcon className="w-[18px] h-[18px]" />
            </IconButton>
          </CustomTooltip>
        </dt>
        <dd className="text-base">{petStatus}</dd>
      </dl>
    </section>
  );
}
